import fetch from "./configure";

export const checkUser = data => fetch.post("/checkUser", data);
export const authCode = data => fetch.post("/authCode", data);
export const makePassword = data => fetch.post("/makePassword", data);
export const authPassword = data => fetch.post("/authPassword", data);
export const getProperty = params => fetch.get("/getProperty", { params });
export const makeAuth = data => fetch.post("/makeAuth", data);
export const updatePasword = data => fetch.post("/updatePassword", data);

export const getSmsMessages = params => fetch.get("/getSmsMessages", { params });
export const getSchoolList = params => fetch.get("/getSchoolList", { params });
